import { DetailsPanelService } from "sharebase-app/services/detailsPanelService";

/**
 * @ngdoc directive
 * @name phoenix.directive:pxAutoFitVirtualRepeat
 * @module phoenix
 * @restrict A
 * @description
 *
 * A directive to automatically size and resize a child md-virtual-scroller-container.
 *
 * @usage
 *
 * <div px-auto-fit-virtual-repeat px-auto-fit-virtual-repeat-offset="1">
 *		<md-virtual-repeat-container></md-virtual-repeat-container>
* </div>
*
*/
export function AutoFitVirtualRepeatDirective(
	$window:ng.IWindowService, 
	$timeout:ng.ITimeoutService,
	sbaDetailsPanelService:DetailsPanelService
) {
	return {
		restrict: 'A',
		link: function (scope, element, attrs) {
			//get an offset if specified
			var offset = element.attr('px-auto-fit-virtual-repeat-offset');
			var intOffset = 0;
			if (offset && typeof parseInt(offset) === 'number') {
				intOffset = parseInt(offset);
			}

			function setHeight() {
				$timeout(function () {
					var _height;
					//subtract 1px for height rounding up to closest px IE: 806.75 rounded to 807, which causes second scrollbar
					_height = (element[0].offsetHeight - 1) - intOffset;

					element.find('md-virtual-repeat-container').css('height', _height + 'px');
					$timeout(function () {
						//https://github.com/angular/material/issues/4314
						scope.$broadcast('$md-resize');
						scope.$broadcast('px-recalculate-virtual-tile-view');
					}, 0);
				}, 0);
			}
			
			//add resize events
			var _timeout;
			function resizeHeight() {
				element.css({ 'overflow-y': 'hidden', 'transition-duration': '0s' }); //removes the scroll bar and transitions while resizing
				$timeout.cancel(_timeout);
				_timeout = $timeout(function () {
					$timeout.cancel(_timeout);
					setHeight();
					element.css({ 'overflow-y': '', 'transition-duration': '' });
				}, 150);
			}

			$window.addEventListener('resize', resizeHeight);
			$window.addEventListener('orientationchange', resizeHeight);
			
			//add state changed event if element or child element houses a ui-view, as the child content may have changed
			if (element[0].querySelectorAll('[ui-view]').length > 0 || element[0].hasAttribute('ui-view')) {
				scope.$on('$stateChangeSuccess', function () {
					$timeout(function () {
						setHeight();
					}, 150);
				});
			}

			//register callback such that opening/closing inline details panel forces a resize
			sbaDetailsPanelService.registerObserver(resizeHeight);

			//run on initial setup
			setHeight();

			scope.$on('$destroy', function () {
				$window.removeEventListener('resize', resizeHeight);
				$window.removeEventListener('orientationchange', resizeHeight);
			});

			//watches to see if the number of rendered virtual repeat items has changed
			scope.$watch(
				function () {
					var count = 0;
					var virtualCount = element.find('md-virtual-repeat-container').attr('virtual-item-count');
					if (virtualCount) {
						if (virtualCount > 0) {
							count = element.find('md-virtual-repeat-container').attr('virtual-item-count');
						}
					}
					return count;
				},
				function () {
					resizeHeight();
				});
			
		}
	};
}

AutoFitVirtualRepeatDirective.$inject = [
	'$window',
	'$timeout',
	'sbaDetailsPanelService'
];


// WEBPACK FOOTER //
// ./src/phoenix/components/autofitVirtualRepeat/autoFitVirtualRepeat.ts